module.exports = __webpack_public_path__ + "static/media/positive.1a66dee8.png";